

































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { Contract } from "@/components/Pages/Scout/elements/ContractPanelWrapper/ContractPanel/types";
import { ScoutPlan } from "@/pb/scout/contract/v1/contract_pb";
import { unixTimeMsToDateStrJPFormat } from "@/helpers/date-helper";

export default defineComponent({
  name: "ContractPanel",
  props: {
    contract: {
      type: Object as PropType<Contract>,
      required: true
    }
  },
  setup(props) {
    const hasValidContract = computed(() => {
      if (props.contract.scoutPlan === ScoutPlan.SCOUT_PLAN_UNSPECIFIED) {
        return false;
      }

      return (
        props.contract.remainingTicketsCount > 0 &&
        props.contract.expirationAtMs !== undefined &&
        props.contract.expirationAtMs > Date.now()
      );
    });

    const contractPlanName = computed(() => {
      switch (props.contract.scoutPlan) {
        case ScoutPlan.SCOUT_PLAN_UNSPECIFIED:
          return "未契約";
        case ScoutPlan.SCOUT_PLAN_FLAT_RATE:
          return "月額定額プラン";
        case ScoutPlan.SCOUT_PLAN_CONVERSION_REWARD:
          return "成果報酬プラン";
        case ScoutPlan.SCOUT_PLAN_FOR_AGENT:
          return "エージェントプラン";
        default:
          return "";
      }
    });

    const convertExpirationAt = computed(() => {
      if (
        props.contract.expirationAtMs === undefined ||
        props.contract.expirationAtMs === 0
      ) {
        return "";
      }

      return unixTimeMsToDateStrJPFormat(props.contract.expirationAtMs);
    });

    const isTicketCountAlert = computed(() => {
      return (
        // チケット残り数が0~10枚のみ評価する
        props.contract.remainingTicketsCount >= 0 &&
        props.contract.remainingTicketsCount <= 10
      );
    });

    return {
      hasValidContract,
      contractPlanName,
      convertExpirationAt,
      isTicketCountAlert
    };
  }
});
